import logo from "./logo.svg";
import { lazy, Suspense } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import Loading from "./screens/Loading";
import Home from "./screens/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
const Illinois = lazy(() => import("./screens/States/illinois"));
const Kansas = lazy(() => import("./screens/States/Kansas"));
const California = lazy(() => import("./screens/States/california"));
const Oregon = lazy(() => import("./screens/States/oregon"));
const Newmexico = lazy(() => import("./screens/States/new-mexico"));
const Alaska = lazy(() => import("./screens/States/alaska"));
const Georgia = lazy(() => import("./screens/States/georgia"));
const Nebraska = lazy(() => import("./screens/States/nebraska"));
const Northdakota = lazy(() => import("./screens/States/north-dakota"));
const Rhodeisland = lazy(() => import("./screens/States/rhode-island"));
const Southdakota = lazy(() => import("./screens/States/south-dakota"));
const Kentucky = lazy(() => import("./screens/States/kentucky"));
const Districtofcolumbia = lazy(() => import("./screens/States/district-of-columbia"));
const Oklahoma = lazy(() => import("./screens/States/oklahoma"));
const Utah = lazy(() => import("./screens/States/utah"));
const Wisconsin = lazy(() => import("./screens/States/wisconsin"));
const Minnesota = lazy(() => import("./screens/States/minnesota"));
const Southcarolina = lazy(() => import("./screens/States/south-carolina"));
const Texas = lazy(() => import("./screens/States/texas-state"));
const Vermont = lazy(() => import("./screens/States/vermont"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Header/>
        <Home/>
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/daily-fantasy-sports-in-texas" element={<Texas />} />
          <Route path="/daily-fantasy-sports-in-illinois" element={<Illinois />} />
          <Route path="/daily-fantasy-sports-in-kansas" element={<Kansas />} />
          <Route path="/daily-fantasy-sports-in-california" element={<California />} />
          <Route path="/daily-fantasy-sports-in-oregon" element={<Oregon />} />
          <Route path="/daily-fantasy-sports-in-new-mexico" element={<Newmexico />} />
          <Route path="/daily-fantasy-sports-in-alaska" element={<Alaska />} />
          <Route path="/daily-fantasy-sports-in-georgia" element={<Georgia />} />
          <Route path="/daily-fantasy-sports-in-nebraska" element={<Nebraska />} />
          <Route path="/daily-fantasy-sports-in-north-dakota" element={<Northdakota />} />
          <Route path="/daily-fantasy-sports-in-rhode-island" element={<Rhodeisland />} />
          <Route path="/daily-fantasy-sports-in-south-dakota" element={<Southdakota />} />
          <Route path="/daily-fantasy-sports-in-kentucky" element={<Kentucky />} />
          <Route path="/daily-fantasy-sports-in-district-of-columbia" element={<Districtofcolumbia />} />
          <Route path="/daily-fantasy-sports-in-south-carolina" element={<Southcarolina />} />
          <Route path="/daily-fantasy-sports-in-minnesota" element={<Minnesota />} />
          <Route path="/daily-fantasy-sports-in-wisconsin" element={<Wisconsin />} />
          <Route path="/daily-fantasy-sports-in-utah" element={<Utah />} />
          <Route path="/daily-fantasy-sports-in-oklahoma" element={<Oklahoma />} />
          <Route path="/daily-fantasy-sports-in-vermont" element={<Vermont />} />
        
 
        </Routes>
        <Footer/>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
